import React, { useEffect, useState } from "react";
import {
  Box,
  Select,
  MenuItem,
  Button,
  FormControl,
  InputLabel,
} from "@mui/material";
import filterService from "../services/filterService";

const FilterHeader = ({ filters, setFilters, showVertical = true, showProject = true, showLocation = true }) => {
  const [options, setOptions] = useState({
    VerticalDescriptions: [],
    ProjectDescriptions: [],
    Locations: [],
  });

 useEffect(() => {
  const fetchOptions = async () => {
    try {
      const data = await filterService.fetchFilters();
      const prependAll = (arr) => {
        const hasAll = arr.some((item) => item.toLowerCase() === "all");
        return arr.length > 0 && !hasAll ? ["All", ...arr] : arr;
      };
      setOptions({
        VerticalDescriptions: prependAll(data.VerticalDescriptions || []),
        ProjectDescriptions: prependAll(data.ProjectDescriptions || []),
        Locations: prependAll(data.Locations || []),
      });
    } catch (err) {
      console.error("Failed to fetch filter options", err);
    }
  };

  fetchOptions();
}, []);


  const handleChange = (key) => (event) => {
    setFilters((prev) => ({
      ...prev,
      [key]: event.target.value,
    }));
  };

  return (
    <Box display="flex" gap={2} flexWrap="wrap" alignItems="center">
      {(options.VerticalDescriptions.length > 0 && showVertical == true) && (
        <FormControl size="small" sx={{ flex: 1, minWidth: 160, width: 320  }}>
          <InputLabel>Vertical</InputLabel>
          <Select
            value={filters.VerticalDescriptions || ""}
            onChange={handleChange("VerticalDescriptions")}
            label="Vertical"
          >
            {options.VerticalDescriptions.map((item) => (
              <MenuItem key={item} value={item}>
                {item}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}

      {(options.ProjectDescriptions.length > 0 && showProject == true ) && (
        <FormControl size="small" sx={{ flex: 1, minWidth: 160 }}>
          <InputLabel>Project</InputLabel>
          <Select
            value={filters.ProjectDescriptions || ""}
            onChange={handleChange("ProjectDescriptions")}
            label="Project"
          >
            {options.ProjectDescriptions.map((item) => (
              <MenuItem key={item} value={item}>
                {item}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}

      {(options.Locations.length > 0 && showLocation) && (
        <FormControl size="small" sx={{ flex: 1, minWidth: 160 }}>
          <InputLabel>Location</InputLabel>
          <Select
            value={filters.Locations || ""}
            onChange={handleChange("Locations")}
            label="Location"
          >
            {options.Locations.map((item) => (
              <MenuItem key={item} value={item}>
                {item}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}

    {(1==0) && (
          <Box sx={{ flexShrink: 0 }}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => console.log("Apply filters:", filters)}
            >
              Apply
            </Button>
          </Box>
    )}
    </Box>
  );
};

export default FilterHeader;
